var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VersionComparator',{scopedSlots:_vm._u([{key:"default",fn:function({ data_ready }){return [_c('CompareAnalogList',{attrs:{"dataReady":data_ready}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }